<script lang="ts">
    import { getSVGTextSize } from "../context";

    export let text = Array<string>();
    export let highlightLineNr = -1;
    export let anchorPosition = 0|1|2|3|4|5|6|7;

    const svgTextSize = getSVGTextSize();

    $: heightInEm = text.length + (text.length -1) * 0.2;
    $: widthInPx = Math.max(...text.map(line => svgTextSize(line).width));

    $: translateX = (() => {
        switch (anchorPosition) {
            // links Mitte
            case 0: return 0;
            // links unten
            case 1: return 0;
            // mitte unten
            case 2: return -widthInPx/2;
            // rechts unten
            case 3: return -widthInPx;
            // rechts Mitte
            case 4: return -widthInPx;
            // rechts oben
            case 5: return -widthInPx;
            // Mitte oben
            case 6: return -widthInPx/2;
            // links oben
            case 7: return 0;
        }
    })();

    $: translateY = (() => {
        switch (anchorPosition) {
            case 0: return -heightInEm/2;
            case 1: return -heightInEm;
            case 2: return -heightInEm;
            case 3: return -heightInEm;
            case 4: return -heightInEm/2;
            case 5: return 0;
            case 6: return 0;
            case 7: return 0;
        }
    })();
</script>

<!-- dominant-baseline="hanging" -->
<!-- dominant-baseline="hanging" wird von Safari scheinbar nicht unterstützt (Stand März 2024) -->
<!-- 
    Achtung: Der Wert für dy bei dem ersten tspan ist geschätzt. Der genaue Wert hängt vom descent der Schriftart ab. 
    Je nach Schriftart, die der svg-Renderer verwendet, kann der Text deshalb in y-Richtung leicht unterschiedlich positioniert sein.
-->
<text
    text-anchor="left"
    pointer-events="none"
    y="{translateY}em"
    font-family="sans-serif"
>
    {#each text as line, lineNr}
        {@const color = lineNr === highlightLineNr ? 'coral' : 'black'}
        {#if lineNr === 0}
            <tspan x="{translateX}" dy="0.85em" fill={color}>{line}</tspan>
        {:else}
            <tspan x="{translateX}" dy="1.2em" fill={color}>{line}</tspan>
        {/if}
    {/each}
</text>